import type { Operation } from '@platform/openapi';
import { reportPeriodOf, type PeriodPreset } from '../report-period.ts';

export const UNASSIGNED_CARRIER = 'unassigned';

export type OrderFilters = {
  readonly carrier: string | null;
  readonly governorate: string | null;
  readonly company: string | null;
  readonly period: PeriodPreset | null;
};

export const NO_ORDER_FILTERS: OrderFilters = {
  carrier: null,
  governorate: null,
  company: null,
  period: null,
};

type ListQuery = NonNullable<Operation<'/admin/orders', 'get'>['parameters']['query']>;

export type OrderNarrowingQuery = Pick<ListQuery, 'carrier' | 'governorate' | 'company' | 'from' | 'to'>;

export const UNNARROWED: OrderNarrowingQuery = {};

export const isFiltered = (filters: OrderFilters): boolean =>
  filters.carrier !== null ||
  filters.governorate !== null ||
  filters.company !== null ||
  filters.period !== null;

export const narrowingQueryOf = (filters: OrderFilters, now: Date): OrderNarrowingQuery => {
  const window = filters.period === null ? null : reportPeriodOf(filters.period, now);
  return {
    ...(filters.carrier === null ? {} : { carrier: filters.carrier }),
    ...(filters.governorate === null ? {} : { governorate: filters.governorate }),
    ...(filters.company === null ? {} : { company: filters.company }),
    ...(window === null ? {} : { from: window.from, to: window.to }),
  };
};
